// employeeService.js
import { apiClient, API_ENDPOINTS } from './api';
import { dataEvents, EVENTS } from '../hooks/useDataEvents';

export const employeeService = {
  // Получить всех сотрудников
  async getAll() {
    try {
      console.log('Загрузка сотрудников...');
      const response = await apiClient.get(API_ENDPOINTS.EMPLOYEES);
      
      let employeesArray = [];
      
      if (response && response.employees && Array.isArray(response.employees)) {
        employeesArray = response.employees;
        console.log(`Загружено ${employeesArray.length} сотрудников`);
      } else if (Array.isArray(response)) {
        employeesArray = response;
        console.log(`Загружено ${employeesArray.length} сотрудников (массив)`);
      } else if (response && response.data && Array.isArray(response.data)) {
        employeesArray = response.data;
        console.log(`Загружено ${employeesArray.length} сотрудников (data поле)`);
      } else if (response && response.data && response.data.employees && Array.isArray(response.data.employees)) {
        employeesArray = response.data.employees;
        console.log(`Загружено ${employeesArray.length} сотрудников (data.employees)`);
      } else {
        console.warn('Неизвестный формат ответа:', response);
      }
      
      return employeesArray;
    } catch (error) {
      console.error('Ошибка загрузки сотрудников:', error);
      throw error;
    }
  },

  // Получить сотрудника по ID
  async getById(id) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.EMPLOYEE(id));
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки сотрудника ${id}:`, error);
      throw error;
    }
  },

  // Создать сотрудника
  async create(data) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.EMPLOYEES, data);
      dataEvents.emit(EVENTS.EMPLOYEE_CREATED, data);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка создания сотрудника:', error);
      throw error;
    }
  },

  // Обновить сотрудника
  async update(id, data) {
    try {
      const response = await apiClient.put(API_ENDPOINTS.EMPLOYEE(id), data);
      dataEvents.emit(EVENTS.EMPLOYEE_UPDATED, { id, ...data });
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка обновления сотрудника ${id}:`, error);
      throw error;
    }
  },

  // Удалить сотрудника
  async delete(id) {
    try {
      await apiClient.delete(API_ENDPOINTS.EMPLOYEE(id));
      dataEvents.emit(EVENTS.EMPLOYEE_DELETED, { id });
      return true;
    } catch (error) {
      console.error(`Ошибка удаления сотрудника ${id}:`, error);
      throw error;
    }
  },

  // Сменить должность сотрудника с выбором сохраняемых обучений
  async changePosition(employeeId, positionId, keepTrainingIds) {
    try {
      console.log(`Смена должности сотрудника ${employeeId} на должность ${positionId}`);
      console.log(`Сохраняемые ID обучений (training.id):`, keepTrainingIds);
      
      const response = await apiClient.post(
        API_ENDPOINTS.EMPLOYEE_CHANGE_POSITION(employeeId),
        {
          position_id: positionId,
          keep_training_ids: keepTrainingIds
        }
      );
      
      dataEvents.emit(EVENTS.EMPLOYEE_UPDATED, { id: employeeId, position_id: positionId });
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка смены должности сотрудника ${employeeId}:`, error);
      throw error;
    }
  },

  // Поиск сотрудников
  async search(query) {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.EMPLOYEES}?search=${encodeURIComponent(query)}`);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка поиска сотрудников:', error);
      throw error;
    }
  },

  // Получить сотрудников по бригаде
  async getByBrigade(brigadeId) {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.EMPLOYEES}?brigade_id=${brigadeId}`);
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки сотрудников бригады ${brigadeId}:`, error);
      throw error;
    }
  },

  // Получить сотрудников по должности
  async getByPosition(positionId) {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.EMPLOYEES}?position_id=${positionId}`);
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки сотрудников должности ${positionId}:`, error);
      throw error;
    }
  },

  // ========== ПОДРАЗДЕЛЕНИЯ ==========
  
  async getAllDepartments() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.DEPARTMENTS);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки подразделений:', error);
      throw error;
    }
  },

  // ========== ДОЛЖНОСТИ ==========
  
  async getAllPositions() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.POSITIONS);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки должностей:', error);
      throw error;
    }
  },

  // ========== БРИГАДЫ ==========
  
  async getAllBrigades() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BRIGADES);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки бригад:', error);
      throw error;
    }
  },

  // ========== КУРСЫ ==========
  
  async getAllCourses() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.COURSES);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки курсов:', error);
      throw error;
    }
  },

  async createCourse(data) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.COURSES, data);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка создания курса:', error);
      throw error;
    }
  },

  // ========== ПРОЦЕССЫ ==========
  
  async getAllProcessStages() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PROCESS_STAGES);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки этапов процессов:', error);
      throw error;
    }
  },

  async getAllSlaTemplates() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SLA_TEMPLATES);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки SLA шаблонов:', error);
      throw error;
    }
  },

  // ========== ПОЛЬЗОВАТЕЛИ ==========
  
  async getAllUsers() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.USERS);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки пользователей:', error);
      throw error;
    }
  },
};